module.exports = __webpack_public_path__ + "static/product-track-inventory-5699c106a489136da038f67149cd63ab.png";